module.exports = __webpack_public_path__ + "static/media/eyeWideLeft.e0585d98.obj";